import React from 'react';
import { Progress } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderPlus } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import {
    createDataSource,
    createGridOptions,
    DataGrid,
    indexCellRenderer,
    LinkCellRenderer,
    TextFilterDefaults,
} from '../common/dataGrid/DataGrid';
import DataGridSelectFilter from '../common/dataGrid/DataGridSelectFilter';
import CommonContext, {
    ApiRoutes,
    AppNavPaths,
} from '../Common';
import { PageHeading, PageWrap } from '../common/forms/FormElements';
import DataGridSelectFloatingFilter from '../common/dataGrid/DataGridSelectFloatingFilter';
import DataGridToolbar from '../common/dataGrid/DataGridToolbar';

class JotFormIndex extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            rowData: [],
        };
        this.onAddJotForm = this.onAddJotForm.bind(this);
    }

    componentDidMount() {
        return this.populateState();
    }

    populateState = async () => {
        const gridOptions = createGridOptions(this);

        const [jotFormTypes] = await Promise.all([
            httpClient.js(ApiRoutes.typeAheads.jotFormTypes()),
        ]);

        gridOptions.components = {
            selectFilter: DataGridSelectFilter,
            selectFloatingFilter: DataGridSelectFloatingFilter,
            nameRenderer: LinkCellRenderer,
        };

        const typeFilterParams = {
            suppressFilterButton: true,
            options: jotFormTypes,
            optionsLabel: 'label',
            optionsValue: 'value',
        };

        gridOptions.columnDefs = [
            {
                flex: 0,
                width: 80,
                headerName: '',
                valueGetter: 'node.id',
                sortable: false,
                cellRenderer: indexCellRenderer,
            },
            {
                colId: 'Description',
                sortable: false,
                headerName: 'Name',
                field: 'description',
                cellRenderer: 'nameRenderer',
                cellRendererParams: {
                    to: (id) => `${AppNavPaths.JotForm}/${id}`,
                    nameField: 'description',
                    idField: 'id',
                    title: 'View this Form',
                },
                filter: 'agTextColumnFilter',
                filterParams: TextFilterDefaults,
                floatingFilter: true,
                floatingFilterComponentParams: {
                    suppressFilterButton: true,
                },
            },
            {
                colId: 'JotFormTypeId',
                sortable: true,
                headerName: 'Form type',
                field: 'jotFormType.description',
                filter: 'selectFilter',
                floatingFilter: true,
                filterParams: typeFilterParams,
                floatingFilterComponent: 'selectFloatingFilter',
                floatingFilterComponentParams: typeFilterParams,
            },
            {
                colId: 'formId',
                headerName: 'Jot Form Id',
                field: 'formId',
                minWidth: 85,
                sortable: false,
            },

        ];
        const ds = createDataSource(ApiRoutes.jotForms.search(), gridOptions);

        this.setState({
            loading: false,
            gridOptions,
            dataSource: ds,
        });
    };

    onAddJotForm = () => {
        this.context.history.push(`${AppNavPaths.JotFormNew}`);
    };

    render() {
        if (this.state.loading) return <Progress />;
        const { rowData, gridOptions } = this.state;
        return (
            <PageWrap>
                <PageHeading>
                    <FontAwesomeIcon
                        icon={faFolderPlus}
                        className="mr-2 text-muted"
                    />
                    <span>Jot Forms</span>
                </PageHeading>
                <DataGridToolbar
                    entity="jot_form"
                    gridApi={this.state.gridApi}
                    dataSource={this.state.dataSource}
                    onAdd={this.onAddJotForm}
                    addLabel="Add Jot Form"
                    hideExcelButton
                />
                <DataGrid
                    domLayout="normal"
                    rowData={rowData}
                    gridOptions={gridOptions}
                    gridStatus={this.state.gridStatus}
                />
            </PageWrap>
        );
    }
}
export default JotFormIndex;
